import { APIClient, JavaAPIClient } from "../lib/apiHelper"

const { post, remove } = new APIClient();
const { remove: _remove, post: _post, get: _get } = new JavaAPIClient();

export default {
  send: (device) => _post('/device', device),
  delete: (device) => _remove('/device?id=' + device),
  check: (uuid) => _get('/device/check?uuid=' + encodeURIComponent(uuid)),
}
